import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';

import { EnvironmentService, ErableHttpService, IdUtils } from '@ecm/consumer';
import { ErrorPageService } from '@ecm/router';

@Injectable({
    providedIn: 'root',
})
export class RemoveContractService {
    /**
     * Transaction properties for BCO monitoring
     */
    private readonly pageId: string;

    private readonly http = inject(ErableHttpService);
    private readonly environmentService = inject(EnvironmentService);
    private readonly errorPageService = inject(ErrorPageService);

    public constructor() {
        this.pageId = IdUtils.generateRandomId();
    }

    /**
     * ContractSelector remove contract query
     * @param {string} cid
     * @returns {Observable<>}
     */
    public removeContract(cid: string): Observable<any> {
        return this.requestRemoveContract(cid);
    }

    /**
     * XHR nested requests to CONTRACT_SELECTOR endpoint
     * @param {string} cid
     * @returns {Observable<any>}
     */
    private requestRemoveContract(cid: string): Observable<any> {
        const env = this.environmentService.instant();
        if (!env.API.DASHBOARD.REMOVE_CONTRACT_URL) {
            this.errorPageService.showDefaultErrorPage();
            return throwError(() => 'remove contract api is not activated');
        }
        return this.http
            .delete(env.API.DASHBOARD.REMOVE_CONTRACT_URL.concat('/', cid), {
                feature: 'dashboard',
                pageId: this.pageId,
                functionality: 'PSUPCTR',
                partner: 'ZGP',
                service: 'contractSelector',
                timeout: 10000,
            })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => error.error.error);
                }),
            );
    }
}
